window.animaweb = {
    cmplz_primary: 'primary',
    cmplz_secondary: 'dark',
};